<template>
<div ref="Section1">
  <div id="container">
  <h1>During January 24 to April 24 in 2024,
  <br> there are 4,047 messages mentioned 
  <br>about "Sea turtle" in Thailand's Social Media</h1>
  </div>
<div ref="mainVisualization"></div>
</div>

<div id ="container2">
  <h2>During the last week of April, there are a lot messages about the Sea turtle in Thailand.</h2>
</div>
<div ref="Section4">
  <div ref="fourthVisualization"></div>
</div>

<div id ="container3">
  <h2> The proportion of where Thai people post about Sea Turtle</h2>
</div>

<div ref="Section2">
  <div ref="secondaryVisualization"></div>
  
</div>
<div id ="container3">
  <h2> The proportion of Keywords about Sea Turtle</h2>
</div>
<div ref="Section3">
  <div ref="thirdVisualization"></div>
</div>
<div id ="container5">
    <h2>Let's explore of Social Media post</h2></div>
  
    <div ref="Section5">
    <div ref = "filter">
      <div ref="slider" class="custom-slider"></div>
    <!-- <div ref="barchart2"></div> -->
    </div>
    <div ref="codex"></div>
    <div ref="gridChartContainer"></div>
    <div ref="waffleChartContainer" style="display: none;">
      <button ref="backButton" style="display: none;" @click="handleBackButton">Back</button>
      <div ref="detailsView"></div>
    </div>
  </div>

</template>

<script>
import * as d3 from 'd3';
import noUiSlider from 'nouislider';
import 'nouislider/dist/nouislider.css';

export default {
  data() {
    return {
      colorScale: d3.scaleOrdinal(d3.schemeCategory10),
      timestamps: [],
      data: []
    };
  },
  mounted() {
    this.fetchData();
    this.fetchSecondaryData();
    this.fetchThirdData();
    this.fetchFourthData();
    this.fetchtrendData();
    this.initD3();
  },
  methods: {
    fetchData() {
      // Fetch data for the main visualization
      fetch('data.json')
        .then(response => response.json())
        .then(data => {
          // Once data is fetched, call the method to create the main visualization
          this.createMainVisualization(data);
        })
        .catch(error => {
          console.error('Error fetching main data:', error);
        });
    },
    fetchSecondaryData() {
        // Fetch data for the secondary visualization
        fetch('data.json') // Replace with the path to your secondary data file
          .then(response => response.json())
          .then(data => {
            // Once data is fetched, call the method to create the secondary visualization
            this.createSecondaryVisualization(data);
          })
          .catch(error => {
            console.error('Error fetching secondary data:', error);
          });
      },
    fetchThirdData() {
      // Fetch data for the secondary visualization
      fetch('translated_summary_keywords.json') // Replace with the path to your secondary data file
        .then(response => response.json())
        .then(data => {
          // Once data is fetched, call the method to create the secondary visualization
          this.createThirdVisualization(data);
        })
        .catch(error => {
          console.error('Error fetching secondary data:', error);
        });
    },
    fetchFourthData() {
      // Fetch data for the secondary visualization
      fetch('summary_date.json')
        .then(response => response.json())
        .then(data => {
          // Parse dates and sort
          data.forEach(d => {
            d.parsedDate = new Date(d.Date);
          });
          data.sort((a, b) => a.parsedDate - b.parsedDate);
          this.createFourthVisualization(data);
        })
        .catch(error => {
          console.error('Error fetching JSON data:', error);
        });
      },
  
//Landing
createMainVisualization(data) {
        const width = window.innerWidth;
        const height = window.innerHeight;
        const dotRadius = 2;
  
        // Main visualization
        const svg = d3.select(this.$refs.mainVisualization).append("svg")
          .attr("width", width)
          .attr("height", height)
          .attr("style", "display: block; margin: auto;");
  
        svg.append("rect")
          .attr("width", width)
          .attr("height", height)
          .attr("fill", "none");
  
        let dots = [];
        data.forEach(item => {
          for (let i = 0; i < item.Counts; i++) {
            dots.push({
              finalX: Math.random() * width,
              finalY: Math.random() * height
            });
          }
        });
  
        svg.selectAll("circle.dot")
          .data(dots)
          .enter().append("circle")
          .attr("class", "dot")
          .attr("cx", dot => dot.finalX)
          .attr("cy", 0) // Start offscreen
          .attr("r", dotRadius);
  
        // Intersection Observer setup if needed
        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              svg.selectAll("circle.dot")
                .transition()
                .duration(400)
                .delay((_, i) => i * 5)
                .attr("cy", dot => dot.finalY);
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.1 });
  
        observer.observe(svg.node());
      },
        createSecondaryVisualization(data) {
  let squareSide = 120; // Fixed size for squares
  const gap = window.innerWidth < 600 ? 60 : 20; // Gap between squares
  const labelHeight = 20; // Space for text below each square
  const minHeight = 15; // Minimum height for inner rectangles

  // Calculate the number of items per row dynamically based on available width
  const itemsPerRow = 8;

  const colorScale = d3.scaleOrdinal(d3.schemeCategory10)
    .domain(data.map(d => d.Source)); // Assuming 'Keywords' is unique

  // Calculate total number of rows
  const totalRows = Math.ceil(data.length / itemsPerRow);

  // Calculate total width and height of the grid
  const gridWidth = itemsPerRow * (squareSide + gap) - gap;
  const gridHeight = totalRows * (squareSide + labelHeight + gap) - gap;

  // Calculate the offsets to center the grid horizontally
  const xOffset = (window.innerWidth - gridWidth) / 2;
  const yOffset = (window.innerHeight - gridHeight) / 2;

  const svg = d3.select(this.$refs.secondaryVisualization).append("svg")
    .attr("width", window.innerWidth)
    .attr("height", window.innerHeight)
    .append("g");

  const chartGroup = svg.append("g")
    .attr("transform", `translate(${xOffset}, ${yOffset})`);

  const maxCount = Math.max(...data.map(d => d.Counts)); // Define maxCount here
  const scaleFactor = 80 / maxCount;

  data.forEach((d, i) => {
    const colIndex = i % itemsPerRow;
    const rowIndex = Math.floor(i / itemsPerRow);

    const x = colIndex * (squareSide + gap);
    const y = rowIndex * (squareSide + labelHeight + gap);

    const g = chartGroup.append("g").attr("transform", `translate(${x}, ${y})`);

    // Ensure inner rectangle has a minimum height
    let rectHeight = d.Counts * scaleFactor;
    rectHeight = Math.max(rectHeight, minHeight);

    // Append outer rectangle
    g.append("rect")
      .attr("class", "outer-container")
      .attr("width", squareSide)
      .attr("height", squareSide)
      .attr("fill", "transparent")
      .attr("stroke", "black")
      .attr("stroke-width", 2);

    // Append inner rectangle positioned at the bottom of the outer rectangle
    const innerRect = g.append("rect")
      .attr("class", "container")
      .attr("width", squareSide)
      .attr("height", rectHeight)
      .attr("y", squareSide - rectHeight)
      .attr("fill", "transparent")
      .attr("stroke-width", 1);

    // Append circles within rectangle
    const dots = Array.from({ length: d.Counts }, () => ({
      x: Math.random() * squareSide,
      y: 0, // Start slightly above the top of the square
      finalY: Math.random() * (rectHeight - 2) + (squareSide - rectHeight + 1), // Adjust finalY to align with the inner rectangle
      color: colorScale(d.Source)
    }));

    const dotElements = g.selectAll("circle.dot")
      .data(dots)
      .enter().append("circle")
      .attr("class", "dot")
      .attr("cx", dot => dot.x)
      .attr("cy", dot => dot.y)
      .attr("r", 2)
      .style("fill", dot => dot.color);

    g.append("text")
      .attr("x", squareSide / 2)
      .attr("y", squareSide + 15)
      .attr("text-anchor", "middle")
      .text(d.Source);

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          dotElements
            .attr("cy", 0) // Reset the dots' positions
            .transition()
            .duration(1000)
            .delay((_, i) => i * 3)
            .attr("cy", dot => dot.finalY);

          observer.observe(entry.target);
        }
      });
    }, { threshold: 0.5 });

    observer.observe(innerRect.node());
  });
},

createThirdVisualization(data) {
  let squareSide = 120; // Fixed size for squares
  const gap = window.innerWidth < 600 ? 60 : 20; // Gap between squares
  const labelHeight = 20; // Space for text below each square
  const minHeight = 15; // Minimum height for inner rectangles

  // Calculate the number of items per row dynamically based on available width
  const itemsPerRow = 8;

  const colorScale = d3.scaleOrdinal(d3.schemeCategory10)
    .domain(data.map(d => d.Keywords)); // Assuming 'Keywords' is unique

  // Calculate total number of rows
  const totalRows = Math.ceil(data.length / itemsPerRow);

  // Calculate total width and height of the grid
  const gridWidth = itemsPerRow * (squareSide + gap);
  const gridHeight = totalRows * (squareSide + labelHeight + gap);

  // Calculate the offsets to center the grid
  const xOffset = (window.innerWidth - gridWidth) / 2;
  const yOffset = (800 - gridHeight) / 2;

  const svg = d3.select(this.$refs.thirdVisualization).append("svg")
    .attr("width", window.innerWidth)
    .attr("height", 800)
    .append("g");

  const chartGroup = svg.append("g")
    .attr("transform", `translate(${xOffset}, ${yOffset})`);

  const totalHeight = totalRows * (squareSide + labelHeight + gap); // Calculate total height of the grid

  data.forEach((d, i) => {
    const maxCount = Math.max(...data.map(d => d.Count)); // Define maxCount here

    const colIndex = i % itemsPerRow;
    const rowIndex = Math.floor(i / itemsPerRow);

    const x = colIndex * (squareSide + gap);
    const y = totalHeight - (totalRows - rowIndex) * (squareSide + labelHeight + gap) + yOffset; // Adjusted y coordinate

    const g = chartGroup.append("g").attr("transform", `translate(${x}, ${y})`);

    const scaleFactor = 80 / maxCount;

    // Ensure inner rectangle has a minimum height
    let rectHeight = d.Count * scaleFactor;
    rectHeight = Math.max(rectHeight, minHeight);

    // Append outer rectangle without assigning it to a variable
    g.append("rect")
      .attr("class", "outer-container")
      .attr("width", squareSide)
      .attr("height", squareSide)
      .attr("fill", "transparent")
      .attr("stroke", "black")
      .attr("stroke-width", 2);

    // Append inner rectangle positioned at the bottom of the outer rectangle
    const innerRect = g.append("rect")
      .attr("class", "container")
      .attr("width", squareSide)
      .attr("height", rectHeight)
      .attr("y", squareSide - rectHeight)
      .attr("fill", "transparent")
      // .attr("stroke", "black")
      .attr("stroke-width", 1);

    // Append circles within rectangle
    const dots = Array.from({ length: d.Count }, () => ({
      x: Math.random() * squareSide,
      y: 0, // Start slightly above the top of the square
      finalY: Math.random() * (rectHeight - 2) + (squareSide - rectHeight + 1), // Adjust finalY to align with the inner rectangle
      color: colorScale(d.Keywords)
    }));

    const dotElements = g.selectAll("circle.dot")
      .data(dots)
      .enter().append("circle")
      .attr("class", "dot")
      .attr("cx", dot => dot.x)
      .attr("cy", dot => dot.y)
      .attr("r", 2)
      .style("fill", dot => dot.color);

    g.append("text")
      .attr("x", squareSide / 2)
      .attr("y", squareSide + 15)
      .attr("text-anchor", "middle")
      .text(d.Keywords);

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          dotElements
            .attr("cy", 0) // Reset the dots' positions
            .transition()
            .duration(1000)
            .delay((_, i) => i * 3)
            .attr("cy", dot => dot.finalY);

          observer.observe(entry.target);
        }
      });
    }, { threshold: 0.5 });

    observer.observe(innerRect.node());
  });
},

createFourthVisualization(data) {
  const margin = { top: 20, right: 30, bottom: 30, left: 50 };
  const width = window.innerWidth - margin.left - margin.right;
  const height = 400 - margin.top - margin.bottom;

  const svg = d3.select(this.$refs.fourthVisualization).append('svg')
    .attr('width', width + margin.left + margin.right)
    .attr('height', height + margin.top + margin.bottom)
    .append('g')
    .attr('transform', `translate(${margin.left},${margin.top})`);

  const xScale = d3.scaleBand()
    .domain(data.map(d => d.parsedDate.toISOString().slice(0, 10)))
    .range([0, width])
    .padding(0.1);

  const yScale = d3.scaleLinear()
    .domain([0, d3.max(data, d => d.MessageCount)])
    .range([height, 0]);

  // Show only the start and end dates
  const startEndDates = [data[0].parsedDate.toISOString().slice(0, 10), data[data.length - 1].parsedDate.toISOString().slice(0, 10)];

  // Add axis
  svg.append('g')
    .attr('transform', `translate(0,${height})`)
    .call(d3.axisBottom(xScale).tickValues(startEndDates));

  // svg.append('g')
  //   .call(d3.axisLeft(yScale));

  // Start with line animation first, then dots
  this.drawLine(svg, data, xScale, yScale, () => {
    this.appendDots(svg, data, xScale, yScale);
  });
},

appendDots(svg, data, xScale, yScale) {
  const dotGroups = svg.selectAll('.dot-group')
    .data(data)
    .enter()
    .append("g")
    .attr("class", "dot-group")
    .attr("transform", d => `translate(${xScale(d.parsedDate.toISOString().slice(0, 10))},0)`);

  const animateDots = (group) => {
    const dotCount = group.MessageCount;
    const xValues = d3.range(dotCount).map(() => Math.random() * xScale.bandwidth());
    const yValues = d3.range(dotCount).map(() => Math.random() * (yScale(0) - yScale(group.MessageCount)));

    const circles = d3.select(`g[transform='translate(${xScale(group.parsedDate.toISOString().slice(0, 10))},0)']`)
      .selectAll('.dot')
      .data(d3.range(dotCount))
      .enter()
      .append('circle')
      .attr('class', 'dot')
      .attr('cx', (_, i) => xValues[i])
      .attr('cy', (_, i) => yScale(0) - yValues[i])
      .attr('r', 1)
      .attr('fill', 'grey')
      .style("opacity", 1);

    circles.each(function (_, i) {
      d3.select(this)
        .transition()
        .delay(i * 100)
        .duration(500)
        .attr('cy', yScale(0))
        .style("opacity", 1);
    });
  };

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const group = d3.select(entry.target);
        group.selectAll('.dot').remove(); // Remove all previous circles
        animateDots(entry.target.__data__); // Re-run animation
      }
    });
  }, { threshold: 0.5 });

  dotGroups.each(function () {
    observer.observe(this);
  });
},

drawLine(svg, data, xScale, yScale, callback) {
  const line = d3.line()
    .x(d => xScale(d.parsedDate.toISOString().slice(0, 10)) + xScale.bandwidth() / 2)
    .y(d => yScale(d.MessageCount))
    .curve(d3.curveCardinal);

  const path = svg.append('path')
    .datum(data)
    .attr('class', 'line')
    .attr('d', line)
    .attr('fill', 'none')
    .attr('stroke', 'blue')
    .attr('stroke-width', 4)
    .style("opacity", 1);

  const pathLength = path.node().getTotalLength();

  const animateLine = () => {
    path
      .style("opacity", 1)
      .attr('stroke-dasharray', `${pathLength} ${pathLength}`)
      .attr('stroke-dashoffset', pathLength)
      .transition()
      .ease(d3.easeCubicInOut)
      .duration(5000)
      .attr('stroke-dashoffset', 0)
      .on("end", callback); // Call the callback after the line animation ends
  };

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        animateLine();
      }
    });
  }, { threshold: 0.5 });

  observer.observe(path.node());
},

    fetchtrendData() {
      d3.json('summary_date.json').then(data => {
        this.setupChart(data);
      }).catch(function(error) {
        console.error('Error fetching JSON data:', error);
      });
    },
    
    setupChart(data) {
      data.forEach(function(d) {
        d.parsedDate = new Date(d.Date);
      });
      data.sort(function(a, b) {
        return a.parsedDate - b.parsedDate;
      });

      const width = 400;
      const height = 50;
      const svg = d3.select(this.$refs.barchart2).append('svg')
          .attr('width', width)
          .attr('height', height)
          .append('g');

      const dates = data.map(d => d.parsedDate.toISOString().slice(0, 10));
      const xScale = d3.scaleBand()
          .domain(dates)
          .range([0, width])
          .padding(0);

      const yScale = d3.scaleLinear()
          .domain([0, d3.max(data, d => d.MessageCount)])
          .range([height, 0]);

      svg.selectAll('.dot')
          .data(data)
          .enter()
          .append("g")
          .attr("class", "dot-group")
          .attr("transform", d => `translate(${xScale(d.parsedDate.toISOString().slice(0, 10))},0)`)
          .each(function(d) {
            const dotCount = d.MessageCount;
            const xValues = d3.range(dotCount).map(() => Math.random() * xScale.bandwidth());
            const yValues = d3.range(dotCount).map(() => Math.random() * (yScale(0) - yScale(d.MessageCount)));
            d3.select(this)
              .selectAll('.dot')
              .data(d3.range(dotCount))
              .enter()
              .append('circle')
              .attr('class', 'dot')
              .attr('cx', (_, i) => xValues[i])
              .attr('cy', (_, i) => yScale(0) - yValues[i])
              .attr('r', 0.5)
              .attr('fill', 'grey');
          });

      const line = d3.line()
          .x(d => xScale(d.Date) + xScale.bandwidth() / 2)
          .y(d => yScale(d.MessageCount))
          .curve(d3.curveCardinal);

      svg.append('path')
          .datum(data)
          .attr('class', 'line')
          .attr('d', line)
          .attr('fill', 'none')
          .attr('stroke', 'blue')
          .attr('stroke-width', 1);
    },

initD3() {

    d3.json('codex.json').then((data) => {
        const svg = d3.select(this.$refs.codex).append('svg')
            .attr('width', 960)
            .attr('height', 800)
            .style('display', 'block')
            .style('margin', 'auto');

            const colorScale = d3.scaleOrdinal(d3.schemeCategory10);
            const timestamps = Object.keys(data).map(k => new Date(k).getTime()).sort();

            // Initialize the tooltip
            const tooltip = d3.select('body').append('div')
                .attr('class', 'tooltip')
                .style('position', 'absolute')
                .style('visibility', 'hidden')
                .style('border', '1px solid black')
                .style('padding', '10px');

            noUiSlider.create(this.$refs.slider, {
    start: [timestamps[0], timestamps[timestamps.length - 1]],
    connect: true,
    range: {
        min: timestamps[0],
        max: timestamps[timestamps.length - 1]
    },
    step: 24 * 60 * 60 * 1000,
    format: {
        to: value => new Date(value).toISOString().substring(0, 10),
        from: value => Number(value)
    }
});

            this.$refs.slider.noUiSlider.on('update', (values) => {
                this.updateVisualization(data, values[0], values[1], svg, colorScale, tooltip);
            });

            // Initial update
            this.updateVisualization(data, timestamps[0], timestamps[timestamps.length - 1], svg, colorScale, tooltip);
        }).catch(error => console.error('Error loading the data file:', error));
    },
updateVisualization(data, startDate, endDate, svg, colorScale, tooltip) {
        svg.selectAll("*").remove();
        const cellSize = 80;
        const cellPadding = 10;
        const numCols = 10;
        const timestamps = Object.keys(data).map(k => new Date(k).getTime()).sort();

        Object.keys(data).forEach(date => {
            const item = { date, sources: Object.entries(data[date]).map(([key, value]) => ({ name: key, count: value })) };
            const index = timestamps.indexOf(new Date(date).getTime());
            const col = index % numCols;
            const row = Math.floor(index / numCols);
            const group = svg.append('g').attr('transform', `translate(${col * (cellSize + cellPadding)}, ${row * (cellSize + cellPadding)})`);
            const isDateSelected = new Date(date).getTime() >= new Date(startDate).getTime() && new Date(date).getTime() <= new Date(endDate).getTime();
            const opacity = isDateSelected ? 1 : 0.2;
            this.drawItems(group, item, opacity, isDateSelected, colorScale, tooltip);
        });
    },

    drawItems(group, item, opacity, isDateSelected, colorScale, tooltip) {
        const innerRect = group.append('rect')
            .attr('width', 80)
            .attr('height', 80)
            .style('fill', 'none')
            .style('stroke', 'grey')
            .style('stroke-width', '1px')
            .style('opacity', opacity);

        if (isDateSelected) {
            innerRect.style('pointer-events', 'all')
                .on('mouseover', () => {
                    group.selectAll('circle').remove();
                    this.showStackedBars(group, item, colorScale);
                    tooltip.style('visibility', 'visible').html(`Date: ${item.date}<br>` + item.sources.map(s => `${s.name}: ${s.count}`).join('<br>'));
                })
                .on('mousemove', (event) => {
                    tooltip.style('left', `${event.pageX + 30}px`).style('top', `${event.pageY}px`);
                })
                .on('mouseout', () => {
                    group.selectAll('rect:not(:first-child)').remove();
                    tooltip.style('visibility', 'hidden');
                    this.drawDots(group, item.sources, opacity, colorScale);
          }).on('click', () => {
            d3.select(this.$refs.codex).style("display", "none");
            d3.json("all.json").then((allDetails) => {
              const details = allDetails.filter(detail => detail.Date === item.date);
              if (details.length > 0) {
                this.displayWaffleChart(details, item.date);
                d3.select(this.$refs.waffleChartContainer).style("display", "block");
              } else {
                console.error("No details available for this date:", item.date);
              }
            }).catch(error => console.error("Error loading message details:", error));
          });
      } else {
        innerRect.style('pointer-events', 'none');
      }
      this.drawDots(group, item.sources, opacity, colorScale);
    },
    showStackedBars(group, item, colorScale) {
      let accumulatedHeight = 0;
      item.sources.forEach(source => {
        const total = item.sources.reduce((acc, src) => acc + src.count, 0);
        const barHeight = (source.count / total) * 80;
        group.append('rect').attr('x', 0).attr('y', accumulatedHeight).attr('width', 80).attr('height', barHeight).attr('fill', colorScale(source.name)).style('opacity', 1).style('pointer-events', 'none');
        accumulatedHeight += barHeight;
      });
    },
    drawDots(group, sources, opacity, colorScale) {
      sources.forEach(source => {
        for (let j = 0; j < source.count; j++) {
          const x = Math.random() * 80;
          const y = Math.random() * 80;
          group.append('circle').attr('cx', x).attr('cy', y).attr('r', 1).attr('fill', colorScale(source.name)).style('opacity', opacity);
        }
      });
    },
    handleBackButton() {
      this.$refs.codex.style.display = 'block';
      this.$refs.gridChartContainer.style.display = 'block';
      this.$refs.waffleChartContainer.style.display = 'none';
      this.$refs.backButton.style.display = 'none';
    },

    displayWaffleChart(details) {
      
      const backButton = d3.select(this.$refs.backButton);
      backButton.style("display", "block");
      const waffleSvg = d3.select(this.$refs.detailsView).html("").append("svg")
        .attr("width", 960)
        .attr("height", 800)
        .style('display', 'block')
        .style('margin', 'auto');
      const colorScale = d3.scaleOrdinal(d3.schemeCategory10).domain(details.map(d => d.Source));
      let x = 0, y = 0;
      const tooltip = d3.select("body").append("div").attr("class", "tooltip").style("position", "absolute").style("visibility", "hidden").style("background-color", "rgba(0, 0, 0, 0.5)").style("padding", "8px").style("border-radius", "4px").style("border", "1px solid #ccc");
      details.forEach((detail, index) => {
        if (index % 10 === 0 && index > 0) { y += 20 + 1; x = 0; }
        waffleSvg.append("rect").attr("x", x).attr("y", y).attr("width", 20 - 1).attr("height", 20 - 1).attr("fill", colorScale(detail.Source)).on("mouseover", (event) => {
          const truncatedText = detail.Text.length > 200 ? `${detail.Text.substring(0, 200)}...` : detail.Text;
          tooltip.style("visibility", "visible").html(`Source: ${detail.Source}<br>Posted by: ${detail["Posted by"]}<br>Engagement: ${detail.Engagement}<br>Sentiment: ${detail.Sentiment}<br>Text: ${truncatedText}`).style("left", `${event.pageX + 15}px`).style("top", `${event.pageY + 15}px`);
        }).on("mouseout", () => {
          tooltip.style("visibility", "hidden");
        }).on("click", () => { window.open(detail.Link, "_blank"); });
        x += 20 + 1;
      });
      d3.select(this.$refs.backButton).on("click", () => {
        d3.select(this.$refs.gridChartContainer).style("display", "block");
        d3.select(this.$refs.waffleChartContainer).style("display", "none");
        backButton.style("display", "none");
      });
    }
  },
 beforeUnmount() {
    if (this.$refs.slider && this.$refs.slider.noUiSlider) {
      this.$refs.slider.noUiSlider.destroy();
    }
  }
}
</script>

<style>
body{
  margin: 0;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    position: relative;
    justify-content: center;
    align-items: center;
  }

.tooltip {
  position: absolute;
  visibility: hidden;
  border: 1px solid black;
  padding: 10px;
}

/* Styling the noUiSlider */
.custom-slider {
  width: 400px; /* Set the width of the slider */
  margin: auto; /* Center the slider horizontally */
  margin-bottom: 40px;
}

/* Ensure the slider fits well visually */
.custom-slider .noUi-target {
    background: #f4f4f4;
    border: 1px solid #ccc;
    border-radius: 10px;
}

.custom-slider .noUi-horizontal {
    height: 15px;
}

.custom-slider .noUi-handle {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #007bff;
    border: 2px solid #007bff;
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
}

.custom-slider .noUi-connect {
    background: #007bff;
}

.custom-slider .noUi-horizontal .noUi-handle {
    top: -3px;
}

.custom-slider .noUi-tooltip {
    background: #007bff;
    color: #fff;
    border-radius: 4px;
    font-size: 12px;
    padding: 4px;
    text-align: center;
}

#Section1 {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: auto; /* หรือตั้งค่าความสูงตามที่จำเป็น */
}

h1 {
  text-align: center; /* จัดข้อความให้ตรงกลาง */
  margin: 0 auto; /* เพิ่มนี้หากต้องการจัดกลาง h1 ภายใน #container มากขึ้น */ 
  z-index: 1; /* ตรวจสอบให้แน่ใจว่า h1 จะอยู่ด้านบนของการแสดงผล */
}

#mainVisualization {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%; /* ตั้งค่าขนาดตามที่ต้องการ */
  z-index: 0; /* Visualization อยู่ใต้ข้อความ */
}
h4{
  text-align: center;
  width: 100%;

}

#Section4{
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 40px;
  justify-content: center;
  align-items: center;
}

#container {
  position: absolute;
  display: flex; /* ใช้ Flexbox */
  justify-content: center; /* จัดกลางแนวนอน */
  align-items: center; /* จัดกลางแนวตั้ง */
  height: 100vh; /* ทำให้คอนเทนเนอร์มีความสูงเต็มหน้าจอ */
  text-align: center; /* จัดข้อความให้กลาง */
  width: 100%;
}
#container2{
  margin: 40px;
  display: flex; /* ใช้ Flexbox */
  justify-content: center; /* จัดกลางแนวนอน */
  align-items: center; /* จัดกลางแนวตั้ง */
  text-align: center; /* จัดข้อความให้กลาง */
}

#container3{
  display: flex; /* ใช้ Flexbox */
  justify-content: center; /* จัดกลางแนวนอน */
  align-items: center; /* จัดกลางแนวตั้ง */
  text-align: center; /* จัดข้อความให้กลาง */
}

#container4{
  display: flex; /* ใช้ Flexbox */
  justify-content: center; /* จัดกลางแนวนอน */
  align-items: center; /* จัดกลางแนวตั้ง */
  text-align: center; /* จัดข้อความให้กลาง */
}

#container5{
  margin: 100px;
  display: flex; /* ใช้ Flexbox */
  justify-content: center; /* จัดกลางแนวนอน */
  align-items: center; /* จัดกลางแนวตั้ง */
  text-align: center; /* จัดข้อความให้กลาง */
}

#Section5{
  position: relative;
  width: 100%; /* Adjust based on your layout needs */
  display: flex;
  flex-direction: column;
  align-items: center; /* Centers children horizontally */
  justify-content: center; /* Centers children vertically */
}

</style>

